class OmetriaPdpRecs extends HTMLElement {
  connectedCallback () {
    // Read config from data attributes
    this.elementId = this.dataset.elementId || 'pdp_recs_1'
    this.targetId = this.dataset.targetId

    if (!this.targetId) {
      console.warn('Ometria PDP recs: targetId not provided')
      return
    }

    // If graphenehc isn't ready yet, retry a few times
    let attempts = 0
    const maxAttempts = 20

    const tryLoad = () => {
      if (window.graphenehc?.load) {
        this.loadRecommendations()
      } else if (attempts < maxAttempts) {
        attempts += 1
        setTimeout(tryLoad, 150)
      } else {
        console.warn('Ometria PDP recs: GrapheneHC not available')
      }
    }

    tryLoad()
  }

  loadRecommendations () {
    const targetSelector = `#${this.targetId}`
    const targetEl = document.querySelector(targetSelector)
    if (!targetEl) {
      console.warn('Ometria PDP recs: target element not found', targetSelector)
      return
    }

    const pageContext = {
      currency_id: window.ometriaCurrency || window.Shopify?.currency?.active,
      page_url: window.location.href,
    }

    try {
      const searchParams = new URLSearchParams(window.location.search)
      const qParamValue = searchParams.get('q') || ''
      if (qParamValue) {
        pageContext.search_text = qParamValue
      }
      if (window.ometriaLanguageId) {
        pageContext.language_id = window.ometriaLanguageId
      }
    } catch (e) {
      console.warn('Ometria PDP recs: error building page_context', e)
    }

    window.graphenehc.load({
      elements: [{ id: this.elementId, target: targetSelector }],
      include: ['products'],
      url: window.location.pathname + window.location.search,
      args: {},
      page_context: pageContext,
      success: () => {
        // The Scriban template is responsible for rendering the carousel markup.
        // If needed, we could trigger any post-load JS here.
      },
      error: error => {
        console.warn('Ometria PDP recs: failed to load recommendations', error)
      },
    })
  }
}

if (!customElements.get('ometria-pdp-recs')) {
  customElements.define('ometria-pdp-recs', OmetriaPdpRecs)
}
